import { Button, typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

export const RankingMethodologyWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const LabelWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  height: 32px;
`;

export const StyledLabel = styled.span`
  ${typographyV2.titleSm};
  color: var(--text-soft);
`;

export const StyledButton = styled(Button)`
  border-radius: 8px;
  border: 1px solid var(--border-default);
  padding: 6px 12px;
`;
